import React from 'react';

import { Typography } from '@gogame/components';

const Remarks = ({ isWeb, isMobile }) => {
  return (
    <div>
      {isWeb ? (
        <React.Fragment>
          <Typography gutterBottom={true}>
            Unused monthly budgets will not be transferred to the following
            month(s).
          </Typography>
          <Typography gutterBottom={true}>
            Campaign criteria, including rates and fees, may be updated and
            agreed by email or any other electronical messaging system usually
            used between the parties to communicate. Unless otherwise agreed by
            email, the parties agree to $100/day daily cap. Any campaign update
            shall apply within 1 business day.
          </Typography>
        </React.Fragment>
      ) : null}

      {isMobile ? (
        <React.Fragment>
          <Typography gutterBottom={true}>
            Conversion Rate (CVR) No. of installs generated from total amount of
            clicks, should be in the range of 0.5% to 15%.
          </Typography>
          <Typography gutterBottom={true}>
            Campaign criteria, including rates and fees, may be updated and
            agreed by email or any other electronical messaging system usually
            used between the parties to communicate.
          </Typography>
          <Typography gutterBottom={true}>
            Unused monthly budgets will not be transferred to the following
            month(s).
          </Typography>
        </React.Fragment>
      ) : null}
    </div>
  );
};

export default Remarks;
